var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("navbar"),
      _vm._m(0),
      _c(
        "div",
        { staticClass: "content search-content" },
        [
          _c("search-com", {
            attrs: { type: "order" },
            on: {
              outputSearchData: _vm.receiveSearchData,
              searchBasic: function ($event) {
                return _vm.getStatistics($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.baseData.loading,
              expression: "baseData.loading",
            },
          ],
          staticClass: "content",
        },
        [
          _c(
            "div",
            { staticClass: "base-data-list" },
            [
              _vm._l(_vm.baseData.list, function (item, index) {
                return [
                  _c("basic-data", {
                    attrs: { basicDataItem: item, basicDataItemIndex: index },
                  }),
                ]
              }),
            ],
            2
          ),
        ]
      ),
      _c("div", { staticClass: "content sale-chart" }, [
        _c("div", { staticClass: "sale-chart-left" }, [
          _c("h3", { staticClass: "card-title" }, [
            _c(
              "label",
              [
                _vm._v(" " + _vm._s(_vm.trend.title) + " "),
                _c(
                  "el-tooltip",
                  {
                    staticClass: "item",
                    attrs: {
                      effect: "dark",
                      content: "不含未提交及已关闭的订单数据",
                      placement: "top",
                    },
                  },
                  [_c("i", { staticClass: "el-icon-question" })]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "staff-button-list" },
              [
                _c("search-com-company", {
                  staticClass: "search-company",
                  attrs: {
                    type: "company",
                    dateArr: _vm.trend.dateArr,
                    type: _vm.trend.type,
                  },
                  on: { outputSearchData: _vm.receiveSearchData },
                }),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.trend.loading,
                  expression: "trend.loading",
                },
              ],
              staticClass: "card-body",
            },
            [
              _c("total-sales", {
                attrs: {
                  config: _vm.trend.config,
                  baseData: _vm.trend.baseData,
                  dataList: _vm.trend.dataList,
                },
              }),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "sale-chart-right" },
          [
            _c("h3", { staticClass: "card-title" }, [
              _c(
                "label",
                [
                  _vm._v("下单金额分布占比 "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content: "所有订单应付金额区间分布",
                        placement: "top",
                      },
                    },
                    [_c("i", { staticClass: "el-icon-question" })]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "staff-button-list" }),
            ]),
            _c("search-com-company", {
              staticClass: "search-company",
              attrs: {
                usePosition: "",
                type: _vm.orderAmount.type,
                dateArr: _vm.orderAmount.dateArr,
              },
              on: { outputSearchData: _vm.receiveSearchData },
            }),
            _c("distribution", {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.orderAmount.loading,
                  expression: "orderAmount.loading",
                },
              ],
              attrs: {
                config: _vm.orderAmount.config,
                dataList: _vm.orderAmount.dataList,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content page-title" }, [
      _c("h2", [_vm._v("订单数据看板")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }